type IProps = {
  language: string
  categoryList: any[]
}

export const useQAList = (props: IProps) => {
  const list = props.language === 'id' ? props.categoryList['id'] : props.categoryList['en']
  const categories = []
  // ------
  let qaList = []
  for (const category in list) {
    const temp = JSON.parse(JSON.stringify(list[category]))
    const questionList = []
    for (const key in temp.list) {
      questionList.push(temp.list[key])
    }
    temp.list = questionList
    categories.push(temp)
    qaList = qaList.concat(temp.list)
  }

  return {
    categories: categories,
    qaList: qaList,
  }
}
